import { uiState } from '../state';
import { guid } from './mini/guid';
import { isLocalStorageAvailable } from './mini/isStorageAvailable';

export function debounce(func, wait) {
    var timeout;
    var delay = wait || 100;
    return function (args) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(this, args);
        }, delay);
    };
}

export function throttle(func, wait = 100) {
    let timer = null;
    let throttlePause;
    return function (...args) {
        if (!throttlePause) {
            func.apply(this, args);
            throttlePause = true;
            if (timer === null) {
                timer = setTimeout(() => {
                    timer = null;
                    throttlePause = false;
                }, wait);
            }
        }
    };
}

export function isSafari() {
    return /apple/i.test(navigator.vendor);
}

export function isMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }
    return false;
}

export function isIpadOS() {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}

export function isOriginSecure() {
    var isSecure = false;
    var protocol = window.location.protocol;
    var hostname = window.location.hostname;

    if (protocol === 'https:') {
        isSecure = true;
    }

    if (isFileProtocol()) {
        isSecure = true;
    }

    if (protocol === 'http:' && (hostname.indexOf('localhost') > -1 || hostname.indexOf('127.0.0.1') > -1)) {
        isSecure = true;
    }

    return isSecure;
}

export function isFileProtocol() {
    var protocol = window.location.protocol;
    return protocol === 'file:';
}

export function isAudioSupported() {
    var available = false,
        fakeGetUserMedia,
        fakeContext;

    fakeGetUserMedia = (navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia ||
        (navigator.mediaDevices && navigator.mediaDevices.getUserMedia));

    fakeContext = window.AudioContext ||
        window.webkitAudioContext ||
        window.mozAudioContext;

    if (fakeGetUserMedia && fakeContext) {
        available = true;
    }

    return available;
}

export function getProjectId() {
    var key;
    if (uiState.project.id) {
        key = uiState.project.id;
        return key.substr(0, key.indexOf('/'));
    }

    return 'none';
}

export function getDeviceId() {
    if (!uiState.project.id) return;
    var deviceIdKey = 'alan-btn-uuid-' + uiState.project.id;
    var deviceId;

    if (isLocalStorageAvailable) {
        deviceId = localStorage.getItem(deviceIdKey);
    }

    if (!deviceId) {
        deviceId = guid();
        if (isLocalStorageAvailable) {
            localStorage.setItem(deviceIdKey, deviceId);
        }
    }
    return deviceId;
}

function printNavigatorFlag(flag) {
    return flag ? '1' : '0';
}

export function getDebugInfo() {
    return `
    Debug Info:
    alanBtn: v.${uiState.lib.version}
    alanSDK: v.${window.alanSDKVersion}
    projectId: ${uiState.project.id || 'unknown'}
    deviceId: ${getDeviceId()}
    navigator: 
    getUserMedia: ${printNavigatorFlag(navigator.getUserMedia)}, 
    mediaDevices: ${printNavigatorFlag(navigator.mediaDevices)}, 
    mediaDevices.getUserMedia: ${printNavigatorFlag(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)},
    webkitGUM: ${printNavigatorFlag(navigator.webkitGetUserMedia)},
    mozGUM: ${printNavigatorFlag(navigator.mozGetUserMedia)},
    msGUM: ${printNavigatorFlag(navigator.msGetUserMedia)},
    window:
    AudioContext: ${printNavigatorFlag(window.AudioContext)},
    webkitAC: ${printNavigatorFlag(window.webkitAudioContext)},
    mozAC: ${printNavigatorFlag(window.mozAudioContext)},
    userAgent: ${navigator.userAgent}
    `;
}